import { FC } from 'react';

type NotificationProps = {
  title: string;
  body: string;
};

const Notification: FC<NotificationProps> = ({ title, body }) => {
  return (
    <div className="toast__container">
      <h2 className="toast__header">{title}</h2>
      <p className="toast__message">{body}</p>
    </div>
  );
};

export default Notification;
